export const defaultBucketEndpoint = "akrotonx-develop.fra1.digitaloceanspaces.com";